import lazyLoadView from './lazyload-view'
import store from '@state/store'

export default [
    // 接待報到
    {
        path: '/check-in',
        name: 'check-in',
        component: () => lazyLoadView(import('@/src/router/views/check-in/index')),
        meta: {
            authRequired: true,
        },
    },
    // 儀表板
    {
        path: '/dashboard',
        name: 'dashboard',
        component: () => lazyLoadView(import('@/src/router/views/dashboard/index')),
        meta: {
            authRequired: true,
        },
    },

    // 商品
    {
        path: '/products',
        name: 'products',
        component: () => lazyLoadView(import('@/src/router/views/product/list')),
        meta: {
            authRequired: true,
        },
    },
    {
        path: '/products/:productId?/add',
        name: 'add-product',
        component: () => lazyLoadView(import('@/src/router/views/product/add')),
        meta: {
            authRequired: true,
            async beforeResolve(routeTo, _, next) {
                const productId = routeTo.params.productId

                if (productId) {
                    try {
                        const matchedProduct = await store.dispatch(
                            'product/fetchSingle',
                            productId
                        )
                        routeTo.params.defaultStep = matchedProduct.activeStep
                        routeTo.params.product = matchedProduct
                        next()
                    } catch (error) {
                        next({
                            name: '404',
                            params: {
                                resource: '商品'
                            }
                        })
                    }
                } else {
                    next()
                }
            },
        },
        props: (route) => ({
            defaultStep: route.params.defaultStep || 1,
            defaultValue: route.params.product,
            productType: (route.params.product && route.params.product.type) || route.query.type,
        }),
    },
    {
        path: '/products/:productId/edit',
        name: 'edit-product',
        component: () => lazyLoadView(import('@/src/router/views/product/edit')),
        meta: {
            authRequired: true,
            beforeResolve(routeTo, routeFrom, next) {
                store
                    .dispatch('product/fetchSingle', routeTo.params.productId)
                    .then((product) => {
                        routeTo.params.product = product
                        next()
                    })
                    .catch(() => {
                        next({
                            name: '404',
                            params: {
                                resource: '商品'
                            }
                        })
                    })
            },
        },
        props: (route) => ({
            defaultValue: route.params.product,
            productType: route.params.product.type,
        }),
    },
    // 客戶
    {
        path: '/member',
        name: 'member',
        component: () => lazyLoadView(import('@/src/router/views/member/list')),
        meta: {
            authRequired: true,
        },
    },
    {
        path: '/member/:memberId',
        name: 'view-member',
        component: () => lazyLoadView(import('@/src/router/views/member/detail')),
        meta: {
            authRequired: true,
            beforeResolve(routeTo, routeFrom, next) {
                store
                    .dispatch('member/fetchSingle', routeTo.params.memberId)
                    .then((member) => {
                        routeTo.params.defaultValue = member
                        next()
                    })
                    .catch(() => {
                        next({
                            name: '404',
                            params: {
                                resource: '客戶'
                            }
                        })
                    })
            },
        },
        props: (route) => ({
            defaultValue: route.params.defaultValue,
        }),
    },
    // 折價券
    {
        path: '/coupon',
        name: 'coupon',
        component: () => lazyLoadView(import('@/src/router/views/coupon/list')),
        meta: {
            authRequired: true,
        },
    },
    {
        path: '/coupon/add',
        name: 'add-coupon',
        component: () => lazyLoadView(import('@/src/router/views/coupon/add')),
        meta: {
            authRequired: true,
        },
    },
    {
        path: '/coupon/:couponId',
        name: 'view-coupon',
        component: () => lazyLoadView(import('@/src/router/views/coupon/detail')),
        meta: {
            authRequired: true,
            beforeResolve(routeTo, routeFrom, next) {
                store
                    .dispatch('coupon/fetchSingle', routeTo.params.couponId)
                    .then((coupon) => {
                        routeTo.params.defaultValue = coupon
                        next()
                    })
                    .catch(() => {
                        next({
                            name: '404',
                            params: {
                                resource: '優惠券'
                            }
                        })
                    })
            },
        },
        props: (route) => ({
            defaultValue: route.params.defaultValue,
        }),
    },
    // 預付方案
    {
        path: '/prepaid',
        name: 'prepaid',
        component: () => lazyLoadView(import('@/src/router/views/prepaid/list')),
        meta: {
            authRequired: true,
        },
    },
    {
        path: '/prepaid/add',
        name: 'add-prepaid',
        component: () => lazyLoadView(import('@/src/router/views/prepaid/add')),
        meta: {
            authRequired: true,
        },
    },
    {
        path: '/prepaid/:prepaidId',
        name: 'view-prepaid',
        component: () => lazyLoadView(import('@/src/router/views/prepaid/detail')),
        meta: {
            authRequired: true,
            beforeResolve(routeTo, routeFrom, next) {
                store
                    .dispatch('prepaid/fetchSingle', routeTo.params.prepaidId)
                    .then((prepaid) => {
                        routeTo.params.defaultValue = prepaid
                        next()
                    })
                    .catch(() => {
                        next({
                            name: '404',
                            params: {
                                resource: '預付方案'
                            }
                        })
                    })
            },
        },
        props: (route) => ({
            defaultValue: route.params.defaultValue,
        }),
    },
    // 訂單
    {
        path: '/orders',
        name: 'orders',
        component: () => lazyLoadView(import('@/src/router/views/order/index')),
        meta: {
            authRequired: true,
        },
    },
    // 分析
    {
        path: '/analytics',
        name: 'analytics',
        component: () => lazyLoadView(import('@/src/router/views/analytics/index')),
        meta: {
            authRequired: true,
            beforeResolve(routeTo, routeFrom, next) {
                if (document.getElementById('gapi')) { // was already loaded
                    next()
                    return
                }
                var scriptTag = document.createElement('script')
                scriptTag.src = 'https://apis.google.com/js/client:platform.js'
                scriptTag.id = 'gapi'
                scriptTag.async = false
                document.getElementsByTagName('head')[0].appendChild(scriptTag)
                scriptTag.addEventListener('load', () => {
                    setTimeout(() => {
                        next()
                    }, 700)

                })

            },
        },
    },
    {
        path: '/staff',
        name: 'staff',
        component: () => lazyLoadView(import('@/src/router/views/staff/list')),
        meta: {
            authRequired: true,
            beforeResolve(routeTo, routeFrom, next) {
                store
                    .dispatch('staff/fetchList')
                    .then(() => next())
                    .catch(() => {
                        next({
                            name: '404',
                            params: {
                                resource: '項目人員'
                            }
                        })
                    })
            },
        },
    },
    // 管理帳號
    {
        path: '/admin',
        name: 'admin',
        meta: {
            authRequired: true,
            beforeResolve(routeTo, routeFrom, next) {
                Promise.all(
                        [store.dispatch('merchant/fetchUsers')],
                        [store.dispatch('merchant/fetchUserGroups')]
                    )
                    .then(() => next())
                    .catch(() => {
                        next({
                            name: '404',
                            params: {
                                resource: '商店管理帳號'
                            }
                        })
                    })
            },
        },
        component: () => lazyLoadView(import('@/src/router/views/admin/list')),
    },
    // 商家設定
    {
        path: '/settings',
        name: 'settings',
        meta: {
            authRequired: true,
            beforeResolve(routeTo, routeFrom, next) {
                Promise.all([
                        store.dispatch('merchant/fetchSingle'),
                        store.dispatch('merchant/fetchPlans'),
                    ])
                    .then(() => next())
                    .catch(() => {
                        next({
                            name: '404',
                            params: {
                                resource: '商家設定'
                            }
                        })
                    })
            },
        },
        component: () => lazyLoadView(import('@/src/router/views/settings/index')),
    },
]
